module.exports = __webpack_public_path__ + "static/media/list-light.68907393.svg";